import { createSlice } from '@reduxjs/toolkit';

const commonState = {
    filter: {
        page: 1,
        pageSize: 20,
        sortType: 1,
    },
    cursor: 0,
};

const initialState = {
    evaluation: {
        ...commonState,
    },
};

const evaluationSlice = createSlice({
    name: 'evaluation',
    initialState,
    reducers: {
        setEvaluationFilter: (state, action) => void (state.evaluation.filter = action.payload),
        setEvaluationCursor: (state, action) => void (state.evaluation.cursor = action.payload),
    },
});

export const evaluationSliceActions = evaluationSlice.actions;

export default evaluationSlice;
